import api from "../config/api"


export const getAllSources = async () => {
    const res = await api.get('/source/');
    return res.data;
}

export const getSourceById = async (id) => {
    const res = await api.get(`/source/?id=${id}`);
    return res.data;
}

export const saveSource = async (data) => {
    const res = await api.post(`/source/`,data,{
         headers: { "Content-Type": "application/json" },
    })
    return res.data;
}

export const deleteSource = async (id) => {
    const res = await api.delete(`/source/?id=${id}`);
    return res.data;
}